import {
  Box,
  Button,
  CircularProgress,
  colors,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { AddBannerImage } from "../../DAL/create";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { data, useNavigate, useParams } from "react-router-dom";
import { GetSingleImage } from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { updateImageData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export const AddUpdateImage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [inputs, setInputs] = useState({
    type: "",
    screen: "",
    isInternalLink: false,
    link: "",
    image: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [formType, setFormType] = useState("add");
  const [type, setType] = useState(false);
  const [loading, setLoading] = useState(false);

  const FetchSingleImageDetail = useCallback(async () => {
    const resp = await GetSingleImage(params?.id);
    if (resp.status == 200) {
      setInputs({
        link: resp?.data?.link,
        type: resp?.data?.type,
        isInternalLink: resp?.data?.isInternalLink,
        screen: resp?.data?.screen,
        image: resp?.data?.url,
      });
      setPreviewImage(resp?.data?.url);
      setFormType("edit");
    }
  }, [params?.id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = (e) => {
    setType(true);
    const file = e.target.files[0];
    setInputs((prev) => ({ ...prev, image: file }));
    setPreviewImage(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputs?.type) {
      setType(true);
      return;
    }

    if (!inputs?.image) {
      setType(true);
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("type", inputs?.type);
    formData.append("link", inputs?.link);
    formData.append("isInternalLink", inputs?.isInternalLink);
    formData.append("screen", inputs?.screen);
    formData.append("image", inputs?.image);

    const resp =
      formType == "add"
        ? await AddBannerImage(formData)
        : await updateImageData(params?.id, formData);
    if (formType == "add" ? resp.status == 201 : resp.status == 200) {
      enqueueSnackbar(
        formType == "edit"
          ? "Image update successfully"
          : "Image added successfully",
        { variant: "success" }
      );
      navigate("/all-images-list");
    } else {
      setLoading(false);
      enqueueSnackbar("Error while uploading image", { variant: "error" });
    }
  };

  useEffect(() => {
    if (params?.id) {
      FetchSingleImageDetail();
    }
  }, [params?.id]);

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };
  return (
    <>
      {loading === true ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress size={50} />
        </Box>
      ) : (
        <Container maxWidth="xl">
          <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <ArrowBackIcon
              onClick={() => navigate(-1)}
              sx={{ cursor: "pointer" }}
            />
            <Typography variant="h6">
              {formType == "add" ? "Add Image" : "Edit Image"}
            </Typography>
          </Box>
          <Grid container spacing={2} sx={{ marginTop: "5px" }}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Link"
                name="link"
                size="small"
                value={inputs?.link}
                fullWidth
                onChange={handleChange}
                sx={inputStyles}
                InputLabelProps={{ sx: labelStyles }}
              />
              {type == true && !inputs?.type && (
                <FormHelperText sx={{ color: "red" }}>
                  {"Link field is required"}
                </FormHelperText>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth size="small" sx={inputStyles}>
                <InputLabel id="demo-simple-select-label" sx={inputStyles}>
                  Type *
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Type *"
                  name="type"
                  value={inputs?.type}
                  onChange={handleChange}
                  sx={inputStyles}
                  InputLabelProps={{ sx: labelStyles }}
                >
                  <MenuItem value={"Banner"}>Banner</MenuItem>
                  <MenuItem value={"Avatar"}>Avatar</MenuItem>
                  <MenuItem value={"Frame"}>Frame</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </Select>
              </FormControl>
              {type == true && !inputs?.type && (
                <FormHelperText sx={{ color: "red" }}>
                  {"Type field is required"}
                </FormHelperText>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth size="small" sx={inputStyles}>
                <InputLabel id="demo-simple-select-label" sx={inputStyles}>
                  Screen *
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Screen"
                  name="screen"
                  value={inputs?.screen}
                  onChange={handleChange}
                  sx={inputStyles}
                  InputLabelProps={{ sx: labelStyles }}
                >
                  <MenuItem value={"Family"}>Family</MenuItem>
                  <MenuItem value={"Ranking"}>Ranking</MenuItem>
                  <MenuItem value={"Wallet"}>Wallet</MenuItem>
                  <MenuItem value={"WalletAdvertise"}>
                    Wallet Advertise
                  </MenuItem>
                  <MenuItem value={"InlineMini"}>Inline Mini</MenuItem>
                  <MenuItem value={"LiveHomePage"}>Live Home page</MenuItem>
                  <MenuItem value={"SplashFullScreen"}>
                    Splash Full Screen
                  </MenuItem>
                  <MenuItem value={"pk"}>Pk</MenuItem>
                  <MenuItem value={"party"}>Party</MenuItem>
                  <MenuItem value={"agency"}>Agency</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth size="small" sx={inputStyles}>
                <InputLabel id="demo-simple-select-label" sx={inputStyles}>
                  Internal Link *
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Internal Link *"
                  name="isInternalLink"
                  value={inputs?.isInternalLink}
                  onChange={handleChange}
                >
                  <MenuItem value={"true"}>True</MenuItem>
                  <MenuItem value={"false"}>False</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={4}>
                  <Typography>Upload Image *</Typography>
                </Grid>
                <Grid item lg={2} sx={{ textAlign: "center" }}>
                  {previewImage && (
                    <img
                      src={type == true ? previewImage : fileUrl + previewImage}
                      alt=""
                      style={{ width: "80%", height: "70px" }}
                    />
                  )}
                </Grid>
                <Grid item lg={6} sx={{ textAlign: "end" }}>
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="upload-button"
                    type="file"
                    onChange={handleImageUpload}
                  />
                  <label htmlFor="upload-button">
                    <Button
                      variant="contained"
                      component="span"
                      className="gradientButton"
                    >
                      Upload
                    </Button>
                  </label>
                </Grid>
              </Grid>
              <FormHelperText sx={{ color: "red" }}>
                {type == true && !inputs?.image && "Image is required"}
              </FormHelperText>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ textAlign: "end" }}
            >
              <Button onClick={handleSubmit} className="gradientButton">
                Submit
              </Button>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};
